import { createSignal } from "solid-js";

// Bumped whenever an incident is acknowledged. The banner polls on a 30s interval, and it is the
// alarm for a bot that is offline and unhandled, so leaving it up for another half minute after
// someone has dealt with the incident makes it lie. Tracking this lets it clear immediately.
const [acknowledgedRevision, setAcknowledgedRevision] = createSignal(0);

export const selfShutoffAcknowledgedRevision = acknowledgedRevision;

export function notifySelfShutoffAcknowledged() {
    setAcknowledgedRevision((n) => n + 1);
}

// Mirrors SelfShutdownTrigger. Shared so the banner, the report and the bot page cannot drift apart.
const TRIGGER_KEYS: Record<number, string> = {
    0: "SELF_SHUTOFF_TRIGGER_BAN",
    1: "SELF_SHUTOFF_TRIGGER_JAIL",
    2: "SELF_SHUTOFF_TRIGGER_STAFF_KICK",
    3: "SELF_SHUTOFF_TRIGGER_BLACKLIST_SIGHTED",
    4: "SELF_SHUTOFF_TRIGGER_BLACKLIST_MESSAGED",
};

export function selfShutoffTriggerKey(trigger: number | null | undefined): string {
    return TRIGGER_KEYS[trigger ?? -1] ?? "SELF_SHUTOFF_TRIGGER_UNKNOWN";
}
